
import { oz } from '@weft/utils';
import { CommitmentLineItemSchema, FixedLineItemSchema, UsageLineItemSchema } from './line-item-schemas';
import { PromotionLineItemSchema } from './line-item-schemas/promotion-line-item/promotion-line-item-schema';

export const LineItemSchema = oz.discriminatedUnion('type', [
  FixedLineItemSchema,
  UsageLineItemSchema,
  CommitmentLineItemSchema,
  PromotionLineItemSchema,
]).openapi('LineItem');

export type LineItem = oz.infer<typeof LineItemSchema>;